<template lang="pug">
.goal-conteiner
  .active-goal
    span.ml-2.text-20-b Активная цель
    active-goal-block( :goal="activeGoal" @editGoal="editGoal").mt-2
  .inactive-goal.mt-5
    div.inactive-goal-header
      span.ml-2.text-20-b Неактивные цели
      span.all.text-16-b( @click="showAllUnactiveGoal" ) Все
    inactive-goal-block.mt-2.mr-5.ml-5( :goal="returnUnactiveFirstGoal" )
  div.button-add.mt-3( @click="addGoal" )
      img(src="@/assets/goalIcon/plus.svg")
      span.text-16-b.ml-2 Добавить цель

  .completed-goals.mt-3
    span.ml-2.text-20-b Завершённые цели
    scroll-list-completed-goals( :listBlocks="completedGoalList" )

</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import ActiveGoalBlock from './ActiveGoalBlock.vue';
import InactiveGoalBlock from './InactiveGoalBlock.vue';
import ScrollListCompletedGoals from './ScrollListCompletedGoals.vue';
export default {
  name: 'GoalPanel',

  components: {
    ActiveGoalBlock,
    InactiveGoalBlock,
    ScrollListCompletedGoals
  },

  mounted() {
    if(!this.goalList) this.loadGoalList()
  },

  computed: {
    ...mapState('goals', ['activeGoal', 'completedGoalList', 'unActiveGoalList', 'goalList']),

    returnUnactiveFirstGoal() {
      return this.unActiveGoalList && this.unActiveGoalList.length ? this.unActiveGoalList[0] : null
    }
  },

  methods: {
    ...mapActions('goals', ['loadGoalList']),
    ...mapMutations('goals', ['setSelectedGoal']),

    addGoal() {
      this.$router.push('/addGoal')
    },

    showAllUnactiveGoal() {
      this.$router.push(`/allGoals/${'unactiveGoals'}`)
    },

    editGoal(goal) {
      this.setSelectedGoal(goal)
      this.$router.push(`/addGoal/${goal.uuid}`)
    }
  }
}
</script>
<style scoped>
.goal-conteiner {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  padding: 42px 18px 0px 18px;
}
.inactive-goal-header {
  width: 100%;
  display: flex;
  align-items: center;
}
.all {
  margin-left: auto;
  color:#5365E5;
}
.completed-goals {
  margin-bottom: 30px;
}
.button-add {
  height: 60px;
  border-width: 2px;
  border-radius: 16px;
  border: 2px dashed #BFDBFE;
  background: #EFF6FF;
  color: #5365E5;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 12px 20px;
}
</style>
